var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.versions && _vm.versions.length > 1)?_c('div',{ref:"scrollBox",staticClass:"sku-version",class:( _obj = {
    'sku-version--average': _vm.versions.length <= 3,
    'sku-version--pad': _vm.versions.length <= 5,
    'sku-version--atmosphere': _vm.hasAtmosphere,
    'sku-version--biggiftbox': _vm.isBigpromotion,
    'sku-version--customatmosphere': _vm.hasCustomAtmosphereBg
  }, _obj['sku-version--' + _vm.discountType] = _vm.hasAtmosphere, _obj )},_vm._l((_vm.versions),function(item,index){
  var _obj;
return _c('div',{key:index,staticClass:"version_item",class:( _obj = {}, _obj[("version-item-" + index)] = true, _obj['version_item--active'] =  index == _vm.checkedSpecItemId - 1, _obj ),attrs:{"tabindex":"0","aria-label":((index == _vm.checkedSpecItemId - 1 ? '已选中' : '未选中') + "," + (_vm.formatSpecName(item.name)))},on:{"click":function($event){return _vm.selectVersion(index, item.name)}}},[_c('span',[_vm._v(_vm._s(_vm._f("formatSpecName")(item.name)))])])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }